import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/problems.css';

const problemLinks = [
	{ icon: 'carbon:time', link: '/servizi/cloud-automazione', color: '#a18cd1' },
	{ icon: 'carbon:chart-line', link: '/servizi/data-engineering', color: '#38d9a9' },
	{ icon: 'carbon:security', link: '/servizi/cybersecurity', color: '#fa709a' },
	{ icon: 'carbon:application-web', link: '/servizi/sviluppo-web', color: '#f5576c' },
	{ icon: 'carbon:machine-learning-model', link: '/servizi/intelligenza-artificiale', color: '#764ba2' },
	{ icon: 'carbon:idea', link: '/servizi/trasformazione-digitale', color: '#4facfe' },
];

const Problems = () => {
	const { t } = useTranslation();
	const items = t('problems.items', { returnObjects: true });

	return (
		<section id="discover" className="problems-section">
			<div className="container-modern">
				<div className="problems-header">
					<span className="problems-badge">{t('problems.badge')}</span>
					<h2 className="problems-title">
						{t('problems.title')} <span className="text-gradient">{t('problems.titleHighlight')}</span>
					</h2>
					<p className="problems-subtitle">
						{t('problems.subtitle')}
					</p>
				</div>

				<div className="problems-grid">
					{items.map((item, index) => (
						<Link
							to={problemLinks[index].link}
							key={index}
							className="problem-card"
							style={{ '--problem-color': problemLinks[index].color }}
						>
							<div className="problem-card-icon">
								<iconify-icon icon={problemLinks[index].icon}></iconify-icon>
							</div>
							<h3 className="problem-card-question">{item.problem}</h3>
							<p className="problem-card-description">{item.description}</p>
							<div className="problem-card-solution">
								<span className="problem-solution-tag">{item.solution}</span>
								<span className="problem-card-arrow">
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</span>
							</div>
						</Link>
					))}
				</div>

				<div className="problems-cta">
					<p className="problems-cta-text">{t('problems.ctaText')}</p>
					<a href="#contact" className="btn-modern btn-primary js-scroll problems-cta-btn">
						{t('problems.ctaButton')}
					</a>
				</div>
			</div>
		</section>
	);
};

export default Problems;
